import { render } from "./VirtualRedTagRedTagged.vue?vue&type=template&id=518659d0&scoped=true&ts=true"
import script from "./VirtualRedTagRedTagged.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagRedTagged.vue?vue&type=script&lang=ts"

import "./VirtualRedTagRedTagged.vue?vue&type=style&index=0&id=518659d0&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518659d0"]])

export default __exports__